var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.876 13.9327L12.0207 11.078C12.8722 10.0158 13.3353 8.69468 13.3334 7.33334C13.3334 4.02134 10.6454 1.33334 7.33337 1.33334C4.02137 1.33334 1.33337 4.02134 1.33337 7.33334C1.33337 10.6453 4.02137 13.3333 7.33337 13.3333C8.69471 13.3353 10.0159 12.8722 11.078 12.0207L13.9327 14.876L14.876 13.9327ZM12 7.33334C12.002 8.54696 11.5294 9.71327 10.6834 10.5833L10.5834 10.6833C9.7133 11.5294 8.54699 12.0019 7.33337 12C4.75471 12 2.66671 9.91134 2.66671 7.33334C2.66671 4.75468 4.75471 2.66668 7.33337 2.66668C9.91137 2.66668 12 4.75468 12 7.33334Z",
    fill: "#646464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1699d45b86d1f01be8513370884248b9.svg";
export { ForwardRef as ReactComponent };